import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CommonStatCard from "../../pt/pt-flow-new/CommonStatCard";
import { getCardLabel, getCardValue } from "../../common-data/Conversions";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";

const LeadKeywordStats = () => {
  const { gymKeywordStatsLoading, gymKeywordStatsError, gymKeywordStats } =
    useSelector((state) => state.prospects);

  const [gymAutomationKeywordStats, setGymAutomationKeywordStats] = useState(
    {}
  );

  const EXCLUDED_KEYS = [
    "asigned_leads",
    "un_asigned_leads",
    "assigned_converted_count",
  ];

  const STAT_ORDER = [
    "total_leads",
    "lead_added_today",
    "added_to_lead",
    "not_added_to_lead",
  ];

  const sortedCards =
    gymAutomationKeywordStats &&
    Object?.entries(gymAutomationKeywordStats)
      ?.sort(([keyA], [keyB]) => {
        const indexA = STAT_ORDER.indexOf(keyA);
        const indexB = STAT_ORDER.indexOf(keyB);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      })
      ?.map(([key, value], index) => (
        <React.Fragment key={index}>
          {!EXCLUDED_KEYS.includes(key) && (
            <CommonStatCard
              tagName={key}
              cardLabel={getCardLabel(key, false, "wati")}
              value={getCardValue(
                key,
                value,
                key === "assigned_converted_lead_value"
                  ? gymAutomationKeywordStats?.assigned_converted_count
                  : 0
              )}
            />
          )}
        </React.Fragment>
      ));

  useEffect(() => {
    if (
      !gymKeywordStatsLoading &&
      !gymKeywordStatsError &&
      gymKeywordStats?.status &&
      gymKeywordStats?.data
    ) {
      setGymAutomationKeywordStats(gymKeywordStats.data);
    } else {
      setGymAutomationKeywordStats({});
    }
  }, [gymKeywordStatsLoading, gymKeywordStatsError, gymKeywordStats]);

  return (
    <div className="cards-container cards-grid-container grid-5 pt-flow-new">
      {gymKeywordStatsLoading ? <ReactVortoxSpinner /> : sortedCards}
    </div>
  );
};

export default LeadKeywordStats;
